import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import * as moment from 'moment';
import { isApiResponse } from '../helpers/utils.js';
import MultiCsvReportDownload from '../components/DownloadReport/MultiCsvReportDownload.jsx';
import './TicketReport.css';

class PerTrendMerchantTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedTeam: null,
      selectedAgeBucket: null,
      detailsData: []
    };
  }

  componentDidMount() {
      if (this.props.shouldLoadData) {
        this.get_filtered_performance_trending_merchant();
        this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    console.log('componentDidUpdate called');
    console.log('Current shouldLoadData:', this.props.shouldLoadData);
    console.log('Previous shouldLoadData:', prevProps.shouldLoadData);
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
        console.log('Condition met - calling API');
        this.get_filtered_performance_trending_merchant();
        this.props.onDataLoaded();
    } else {
        console.log('Condition NOT met');
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#merchantTrendingTable')) {
      $('#merchantTrendingTable').DataTable().clear().destroy();
    }
  }

  get_filtered_performance_trending_merchant() {
    var that = this;
    if(this.props.shouldLoadData) {
    console.log("Performance Trending Merchant Tab");
    console.log(this.props)
    const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        group_by:'merchant',
        report_code:'performance_trending_merchant_wise',
        download: 0
    }

    isApiResponse(false);

    if ($.fn.DataTable.isDataTable('#merchantTrendingTable')) {
      $('#merchantTrendingTable').DataTable().clear().destroy();
    }

    var merchantTrendingTable = $('#merchantTrendingTable').DataTable({
       order:[],
        "processing": true,
        "serverSide": true,
        "bDestroy": true,
        "paging": true,
        "pageLength": 5,
        "bInfo" : false,
        "autoWidth": true,
        "responsive": false,
        "searching": true,
        "lengthMenu": [[5, 25, 50, 100, 500, -1], [5, 25, 50, 100, 500, "All"]],
        ajax: {
        url: config.get('API_URL') + "/ServiceReport/performance_trending",
        type: 'POST',
        data: postData,
            dataSrc:function ( json ) {
                isApiResponse(true);
                that.setState({
                    isChange: false
                })
                return json.data;
            },
            beforeSend: function(request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            error: function (data) {
                isApiResponse(true);
                alert("Failed to load data. Please try again");
                console.log("error", data);
            },
            complete: function (data) {
                isApiResponse(true)
                console.log("complete", data);
            },
        },
      columns: [
        { data: 'Merchant Name', width: '220px' },
        { data: 'MTD' },
        { data: 'M-1' },
        { data: 'M-2' },
        { data: 'M-3' },
        { data: 'M-4' },
        { data: 'M-5' },
        { data: 'M-6' }
      ],
      columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-220'>${val}</div>`;
            }
          },
          {
            // Make all numeric columns clickable
            targets: [1, 2, 3, 4, 5, 6, 7],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({
                  cursor: 'pointer',
                });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          }
        ]
    });
}
  };

handleCellClick(rowData, colIndex) {
    console.log(rowData)
    const merchantName = rowData['Merchant Name'];

    // Map column index to month column
    const monthColumns = {
      1: 'MTD',
      2: 'M-1',
      3: 'M-2',
      4: 'M-3',
      5: 'M-4',
      6: 'M-5',
      7: 'M-6'
    };

    const monthColumn = monthColumns[colIndex];

    console.log('Clicked:', merchantName, monthColumn);

    this.setState({
      showDetails: true,
      selectedTeam: merchantName,
      selectedAgeBucket: monthColumn
    }, () => {
      this.loadDetailsData();
    });
  }

  loadDetailsData() {
    const that = this;
    const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        group_by: 'merchant',
        report_code:'performance_trending_merchant_wise_details',
        group_value: this.state.selectedTeam,
        month_column: this.state.selectedAgeBucket,
        download: 0
    };

    isApiResponse(false);

    if ($.fn.DataTable.isDataTable('#DetailsTable')) {
      $('#DetailsTable').DataTable().clear().destroy();
    }

    var DetailsTable = $('#DetailsTable').DataTable({
      order: [[0, 'desc']],
      processing: true,
      serverSide: true,
      bDestroy: true,
      paging: true,
      pageLength: 5,
      bInfo: true,
      sPaginationType: 'simple_numbers',
      autoWidth: false,
      responsive: false,
      searching: true,
      lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
      ajax: {
        url: config.get('API_URL') + '/ServiceReport/performance_trending_details',
        type: 'POST',
        data: postData,
        dataSrc: function (json) {
          isApiResponse(true);
          return json.data;
        },
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', localStorage.usertoken);
        },
        error: function (data) {
          isApiResponse(true);
          alert('Failed to load details. Please try again');
          console.log('error', data);
        },
        complete: function (data) {
          isApiResponse(true);
          console.log('complete', data);
        }
      },
      columns: [
        { data: 'Ticket Number', width: '100px' },
        { data: 'Product Name', width: '120px' },
        { data: 'Merchant Name', width: '180px' },
        { data: 'Store Name', width: '120px' },
        { data: 'Status', width: '100px' },
        { data: 'Date of Issue', width: '110px' },
        { data: 'Date Resolved', width: '110px' },
        { data: 'TAT', width: '100px' },
        { data: 'Issue Category', width: '150px' },
        { data: 'Current Team Name', width: '120px' },
        { data: 'Current Team Member Name', width: '150px' },
        { data: 'Channel Name', width: '100px' }
      ],
      columnDefs: [
        {
            targets: 0, // Ticket Number column
            render: function (data) {
              const val = data == null ? '' : String(data);
              if (that.props.object_type === 'Innoviti') {
                return `<div class='text-wrap'>
                  <a href="https://innovitiservice.freshdesk.com/a/tickets/${val}"
                     target="_blank"
                     rel="noopener noreferrer"
                     style="color:#7b1fa2; text-decoration:underline;">
                    ${val}
                  </a>
                </div>`;
              }
              return `<div class='text-wrap'>${val}</div>`;
            }
          },
        {
          targets: '_all',
          render: function (data) {
            const val = data == null ? '' : String(data);
            return `<div class='text-wrap'>${val}</div>`;
          }
        }
      ]
    });
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedTeam: null,
      selectedAgeBucket: null
    });
  }

  TicketDetailsDownloadCheck(type, e){
    var fn='performance_trending_merchant_wise_details.csv.gz';
    var url = '/service_reports/performance_trending_details';
    var report_code = "performance_trending_merchant_wise_details"
    var group_by = 'merchant'

    let filters = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        download: 1,
        report_code:report_code,
        user_id: this.state.user_id,
        merchant: this.props.merchantID,
        chain: this.props.chainID || [],
        store: this.props.storeID,
        issue_category: this.props.cf_issue_sub_category,
        city: this.props.city,
        channel: this.props.channel,
        product: this.props.product,
        team: this.props.team,
        group_by:group_by,
        group_value: this.state.selectedTeam,
        month_column: this.state.selectedAgeBucket
    }
    this.refs.downloadAllReport.downLoadReport(filters, url, fn, 190);
  }

  render() {
    const { showDetails, selectedTeam, selectedAgeBucket } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
          <table id="merchantTrendingTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th className="merchant-header-default">Merchant Name</th>
                <th className="merchant-header-default">MTD</th>
                <th className="merchant-header-default">M-1</th>
                <th className="merchant-header-default">M-2</th>
                <th className="merchant-header-default">M-3</th>
                <th className="merchant-header-default">M-4</th>
                <th className="merchant-header-default">M-5</th>
                <th className="merchant-header-default">M-6</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
        {showDetails && (
          <div className="ticket-details-section" style={{ marginTop: '10px' }}>
            <div className="col-md-9 no-padd">
                <div className="details-header">
                  <h3 >
                    Ticket Details - {selectedTeam}
                    {selectedAgeBucket && ` (${selectedAgeBucket})`}
                  </h3>
                   <hr/>
                </div>
            </div>

            <div className="col-md-3 pull-right">
                <div className="r-p-menu">
                    <div className="report-header-icons">
                         <div className="icon-button download-icon"  title="Download Report" onClick={this.TicketDetailsDownloadCheck.bind(this)}>
                                <i className="fa fa-download"></i>
                          </div>
                          <div className="icon-button print-icon"  title="Close Report" onClick={() => this.closeDetails()}>
                            <i className="fa fa-close"></i>
                         </div>
                    </div>
                </div>
            </div>
            <div className = "clearfix"></div>

            <div className="content-tdetails-table table-full-width table-responsive">
              <table id="DetailsTable" className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th className="merchant-header-default">Ticket Number</th>
                    <th className="merchant-header-default">Product Name</th>
                    <th className="merchant-header-default">Merchant Name</th>
                    <th className="merchant-header-default">Store Name</th>
                    <th className="merchant-header-default">Status</th>
                    <th className="merchant-header-default">Date of Issue</th>
                    <th className="merchant-header-default">Date Resolved</th>
                    <th className="merchant-header-default">TAT</th>
                    <th className="merchant-header-default">Issue Category</th>
                    <th className="merchant-header-default">Current Team Name</th>
                    <th className="merchant-header-default">Current Team Member Name</th>
                    <th className="merchant-header-default">Channel Name</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
            <MultiCsvReportDownload ref="downloadAllReport" />
          </div>
        )}
      </div>
    );
  }
}

export default PerTrendMerchantTab;